class AdpNotificationsListController {
  constructor() {
    this.name = 'adpList';
  }
}

export default AdpNotificationsListController;



// WEBPACK FOOTER //
// ./src/app/components/adpNotificationsList/adpNotificationsList.controller.js